import WalletBifoldIcon from '@mdi/svg/svg/wallet-bifold.svg?react';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import BuildIcon from '@mui/icons-material/Build';
import CloudUpload from '@mui/icons-material/CloudUpload';
import ContactsIcon from '@mui/icons-material/Contacts';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import GroupsIcon from '@mui/icons-material/Groups';
import LanguageIcon from '@mui/icons-material/Language';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import NightShelterIcon from '@mui/icons-material/NightShelter';
import PublicIcon from '@mui/icons-material/Public';
import ReceiptLong from '@mui/icons-material/ReceiptLong';
import StorageIcon from '@mui/icons-material/Storage';
import TuneIcon from '@mui/icons-material/Tune';
import { styled } from '@mui/material';
import { PaletteColor } from '@mui/material/styles';
import React from 'react';

type Props = {
    domain: string;
    color:
        | 'primary'
        | 'action'
        | 'error'
        | 'info'
        | 'success'
        | 'warning'
        | 'text.primary'
        | 'text.secondary';
};

const StyWalletBifoldIcon = styled(WalletBifoldIcon, {
    shouldForwardProp: (prop) => !['color'].includes(prop),
    name: 'StyEditorIcon',
})<Pick<Props, 'color'>>(({ theme, color }) => {
    const colorMap = {
        'text.primary': theme.palette.text.primary,
        'text.secondary': theme.palette.text.secondary,
    };
    const isTextColor = color === 'text.primary' || color === 'text.secondary';

    const paletteColor = !isTextColor
        ? (theme.palette[color] as PaletteColor)
        : undefined;
    return {
        fill: isTextColor ? colorMap[color] : paletteColor?.main,
        height: '24px', // empiric value to match the size of MUI icons
    };
});

const DOMAIN_ICONS: Record<string, React.ElementType> = {
    hr: GroupsIcon,
    finance: StyWalletBifoldIcon,
    technical_services: BuildIcon,
    citizen_relation: ContactsIcon,
    population: FamilyRestroomIcon,
    global: PublicIcon,
    open_data: LanguageIcon,
    misc: MiscellaneousServicesIcon,
    project_management: FolderSpecialIcon,
    VIEW: StorageIcon,
    CSV: CloudUpload,
    manty_budget: AccountBalanceIcon,
    extraction_logs: ReceiptLong,
    mad: Diversity3Icon,
    urban_planning: LocationCityIcon,
    housing_population: NightShelterIcon,
    unclassified: TuneIcon,
};

const DomainIcon = ({ domain, color }: Props) => {
    const IconComponent = DOMAIN_ICONS[domain] ?? FolderSpecialIcon;
    return <IconComponent color={color} />;
};

export default DomainIcon;
